class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.cartAmount = Number(this.getAttribute('data-cart-amount')) || 0;
    this.targetType = this.getAttribute('data-target-type') || 'total_price';
    this.hideOnEmpty = this.getAttribute('data-hide-on-empty') === 'true';
    this.sectionId = this.getAttribute('data-section-id');
    this.originalLabel = this.getAttribute('data-original-label');
    this.successLabel = this.getAttribute('data-success-label');
    this.locale = window?.Shopify?.locale || 'en';
    this.currency = window?.Shopify?.currency?.active || 'USD';
    this.country = window?.Shopify?.country || 'US';
    if (this.originalLabel && this.successLabel) {
      this.chekCart();
      this.initCartObserver();
    }
  }

  chekCart = async () => {
    const cart = await this.getCart();
    const cartValue = cart[this.targetType];

    if (this.hideOnEmpty) {
      this.updateSectionState(cart.items.length > 0);
    }

    if (typeof cartValue !== 'number') {
      return;
    }

    const remainingAmount = this.cartAmount - cartValue;

    if (remainingAmount > 0) {
      if (this.originalLabel.includes('{amount}')) {
        const remainingMoney = this.convertToMoney({
          amount: remainingAmount / 100,
          locale: this.locale,
          currency: this.currency,
          country: this.country,
          removeTrailingZeros: false,
        });
        const labelValue = this.originalLabel.replace(
          '{amount}',
          remainingMoney,
        );
        this.innerHTML = labelValue;
        return;
      }
      this.innerHTML = this.originalLabel;
      return;
    }
    this.innerHTML = this.successLabel;
    return;
  };

  updateSectionState = (show = false) => {
    const section = document.querySelector(
      `#FreeShippingBar-${this.sectionId}`,
    );
    if (!section) {
      return;
    }

    if (show) {
      section.classList.remove('hide');
    } else {
      section.classList.add('hide');
    }
  };

  getCart = async () => {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (!cart) {
        return null;
      }

      return cart;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  convertToMoney = ({
    amount,
    locale,
    currency,
    country,
    removeTrailingZeros = false,
  }) => {
    const finalAmount = typeof amount === 'string' ? Number(amount) : amount;

    const localeString = `${locale || 'en'}-${country || 'US'}`;

    const fixedAmount = Number(finalAmount.toFixed(2));

    let formattedAmount = fixedAmount.toLocaleString(localeString, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: removeTrailingZeros ? 0 : 2,
      maximumFractionDigits: removeTrailingZeros ? 2 : 2,
    });

    if (removeTrailingZeros) {
      const decimalSeparator = (1.1).toLocaleString(localeString).charAt(1);
      const amount = formattedAmount.match(/-?\d+(\.\d+)?/)?.[0] || '0';
      if (amount.length === 0) {
        formattedAmount += `${decimalSeparator}00`;
      } else {
        formattedAmount = formattedAmount
          .replace(new RegExp(`\\${decimalSeparator}0+$`), '')
          .replace(new RegExp(`\\${decimalSeparator}$`), '');
      }
    }

    return formattedAmount;
  };

  initCartObserver = () => {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((rawEntry) => {
        const entry = rawEntry.toJSON();
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
          entry.initiatorType,
        );
        const regex = /\/cart(\/(?!\.js\b)[^ ]*|$)/;
        const isCartChangeRequest = regex.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.chekCart();
        }
      });
    });

    cartObserver.observe({ entryTypes: ['resource'] });
  };
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
